export default __webpack_public_path__ + "static/media/background.481cf427.svg";